<div [formGroup]="scheduleDateTimeFormGroup">
    <div class="optional-checkbox single-radio-btn">
        <p-checkbox class="schedule-checkbox" formControlName="scheduleCancelOption" [binary]="true"
            inputId="schedule-cancel" (onChange)="onScheduleCancelOptionChange($event)">
        </p-checkbox>
        <label for="scheduleCancelOption"
            [innerHTML]="isScheduleCancelBookingMessage ? scheduleOptionTitle.scheduledOption.payRepayTitle : scheduleOptionTitle.scheduledOption.title"></label>
    </div>
      <div *ngIf="bookingScheduledDate && scheduleDateTimeFormGroup.get('scheduleCancelOption')?.value" class="pass-err">{{reScheduleWarningMessage}}</div>

<div *ngIf="scheduleDateTimeFormGroup.get('scheduleCancelOption')?.value">
        <div class="date-outer">
            <label for="scheduleDate">Schedule Date & Time<span class="custom-star">*</span></label>
            <div class="custom-select2 custom-date-calender schedule-outer">
                <div class="custom-pcalender">
                    <p-calendar #schedileDate [showTime]="false" dateFormat="M dd, yy" formControlName="scheduleDate"
                        inputId="scheduleDateId" appendTo="body" [inputStyle]="{'width':'100%'}" [readonlyInput]="true"
                        [minDate]="minSelectableDate" [maxDate]="maxSelectableDate" (onSelect)="onDateChange($event)"
                        placeholder="Select date"></p-calendar><img [calendarOpener]="schedileDate"
                        src="assets/images/date-calender.png" alt="calender"/>

                    <div class="error-outer">
                        <div
                            *ngIf="scheduleDateTimeFormGroup.get('scheduleDate')?.hasError('required')  && (scheduleDateTimeFormGroup.get('scheduleDate')?.dirty || scheduleDateTimeFormGroup.get('scheduleDate')?.touched)">
                            <div class="validation-error"> Schedule date is required*</div>
                        </div>
                    </div>
                </div>
                <div class="pdate-outer" [class.disabled-dropdown]="!schedileDate?.value">
                    <div class="date-outer">
                        <div class="custom-select2 custom-date-calender">
                            <p-dropdown [options]="timeOptions" formControlName="scheduleTime" #scheduleTime (onChange)="onTimeChange($event)"
                                placeholder="Select time" optionLabel="name" optionValue="value" appendTo="body"
                                [style]="{'width':'100%'}"></p-dropdown><img class="dropdown-icon"
                                src="assets/images/time-icon.svg" (click)="openTimeDropdown()" alt="time"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
